

import { useContext, useEffect, useState } from 'react'

import { getLanguage } from 'react-multi-lang'
import { orderStatus } from '../../../services/api/api'
import { OrderStatus } from '../../../components/OrderStatus'
import SettingContext  from '../../../services/context/setting-contentxt/setting-context'
import Box from '@mui/material/Box'
import CircularProgress  from '@mui/material/CircularProgress'
import { useAPI } from '../../../services/hoc/useAPI'

interface iProps {current_Status:orderStatus,id:number,resetForm:Function,unChangable:boolean,
    haveWaitPermission:boolean,haveRejectPermission:boolean,haveApprovePermission:boolean
    }
export function UpdateOrderStatus({current_Status,id,resetForm,unChangable,
    haveApprovePermission,haveRejectPermission,haveWaitPermission
}:iProps){

    const {setAlert}=useContext(SettingContext)

    const [loading,setLoading]=useState(false)
    
const api = useAPI()
const [choice,setChoice]=useState<orderStatus | undefined>(undefined)
const changeOrderStatus=()=>{
    if (unChangable) return
    setLoading(true)
    api.purchaseOrder().changeOrderStatus({id,order_status:choice??'Approved'})
    .then((res:any)=>{
        if (res.data) {
            setChoice(choice)
            setLoading(false)
            setAlert((pre:any)=>({...pre,openAlert:true,alertMessage:getLanguage()==='en'?
        "you changed order status successfully":"تم تغيير حالة الطلبية بنجاح",
    alertType:'success'}))
    resetForm(res)
           
        }
    })
    .catch((err:any)=>{
        setLoading(false)
        setAlert((pre:any)=>({...pre,openAlert:true,alertMessage:getLanguage()==='en'?
        "Something wrong happend":"حدث خطأ ما",
    alertTtype:'error'}))
            
        })
    }
useEffect(()=>{
if (choice  ) {
    changeOrderStatus()
}

},[choice])
const handleChoice= (value:orderStatus)=>
  { 
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
     unChangable ?()=>{} :
    setChoice(value)
}


let status=choice || current_Status
    return (
      <Box sx={{
        display:'flex',
        justifyContent:'center',
      }} >
        
       {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
       loading?
        <CircularProgress size={10} />
       :
        <>
         <OrderStatus 
                           order_status={'Pending'}
                           border= {
                            status=== 'Pending'?
                           "1px solid orange" : "1px solid gray"}
                           color={    status === 'Pending'? "orange":"gray"}
                           setChoice={handleChoice}
                            disabled={!haveWaitPermission}
                           />
                              <OrderStatus 
                           order_status={'Approved'}
                           border={status === 'Approved'?
                           "1px solid green":
                           "1px solid gray"}
                           color={status === 'Approved'?"green": "gray"}
                           margin='0px 10px'
                           disabled={!haveApprovePermission}
                           setChoice={handleChoice}
                           />
                        
                           <OrderStatus 
                           order_status={"Rejected"}
                           border={status=== 'Rejected'?
                           "1px solid red":
                            "1px solid gray"}
                           color={status=== 'Rejected'?
                           "red":
                            "gray"}
                            setChoice={handleChoice}
                            disabled={!haveRejectPermission}
                           />     
                        </> }
      </Box>
    )
}